var map = {
	"./quality-nopass-info-icon.svg": "RCqP",
	"./quality-pass-info-icon.svg": "i1qd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6v0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/quality\-.*\-info\-icon\.svg$
// module id = 6v0c
// module chunks = 26